// Lightweight auth debug utility
// Enable with ?authDebug=1 or localStorage.setItem('authDebug','1')

export type AuthDebugEvent = {
  ts: string;
  where: string;
  msg: string;
  data?: unknown;
};

declare global {
  interface Window {
    __authLogs?: AuthDebugEvent[];
  }
}

const isEnabled = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('authDebug') === '1') return true;
    return localStorage.getItem('authDebug') === '1';
  } catch {
    return false;
  }
};

export const authDebugEnabled = isEnabled();

export function authLog(where: string, msg: string, data?: unknown) {
  if (!authDebugEnabled) return;
  const evt: AuthDebugEvent = {
    ts: new Date().toISOString(),
    where,
    msg,
    data,
  };
  // Store on window for quick inspection
  window.__authLogs = (window.__authLogs || []).concat(evt);
  // Emit event so overlay can update
  document.dispatchEvent(new CustomEvent('authlog', { detail: evt }));
  // Also output to console for dev tools
   
  console.info('[AUTH DEBUG]', evt);
}
